<template>
  <div>
    <oil-form
        v-if='loading'
        :title='formTitle'
        :items='waybill'
        :keys='keys'
        :inputIsEdit='true'
        :createForm='false'
        :success-message='message'
        @AppendixId='changeAppendix'
        @EmpowermentId='changeEmpowerment'
        @OrderId='changeOrder'
        @VehicleTrailer1='changeVehicleTrailer1'
        @VehicleTrailer2='changeVehicleTrailer2'
        @TerminalId='changeTerminal'
        :formCallback='formCallback'
    >
      <template v-slot:header='{id}'>
        <v-tooltip bottom>
          <template v-slot:activator='{ on, attrs }'>
            <v-btn v-if='id' class='mr-6' type='button' icon
                   @click="openPdf(id,'waybill/print')"
                   v-bind='attrs'
                   v-on='on'
            >
              <v-icon>
                mdi-pdf-box
              </v-icon>

            </v-btn>
          </template>
          <span>СКАЧАТЬ И ПЕЧАТЬ</span>
        </v-tooltip>
      </template>
      <template v-slot:Buyer.Id='{rules,input}'>
        <v-autocomplete
            :items='buyers$'
            v-stream:keyup.native='searchCompany$'
            hide-no-data
            :disabled='!input.isEdit'
            :clearable='!isReadonlyy.buyer'
            :rules='[...rules]'
            dense
            outlined
            :readonly='isReadonlyy.buyer'
            @change='changeBuyer'
            hide-selected
            :value='waybill.Buyer.CompanyName'
            item-text='CompanyName'
            label='Выбрать покупателя'
            return-object
        ></v-autocomplete>
      </template>
      <template v-slot:Terminal.Id='{input}'>
        <div class='parent'>
          <v-autocomplete
              :items='terminals'
              v-model='waybill.Terminal'
              :disabled='!input.isEdit'
              clearable
              @change='changeTerminal'
              dense
              outlined
              hide-selected
              item-value='Id'
              item-text='Name'
              label='Пункт погрузки'
              return-object
          />
          <v-checkbox
              class='absolute'
              :disabled='!input.isEdit'
              v-model='waybill.TerminalShow'
              hide-details
              outlined
              dense
          />
        </div>
      </template>
      <template v-slot:Contract.Id='{rules}'>
        <v-autocomplete
            :items='contracts$'
            v-stream:keyup.native='searchContract$'
            hide-no-data
            :rules='[...rules]'
            clearable
            @change='changeContract'
            dense
            outlined
            :value='waybill.Contract.Number'
            hide-selected
            item-text='Number'
            label='Выбрать договор'
            return-object
        ></v-autocomplete>
      </template>

      <template v-slot:NoTransport='{rules,input}'>
        <v-radio-group v-model='waybillNoTransport' class='py-0 my-0'>
          <v-radio label='с транспортом' :value='false'></v-radio>
          <v-radio label='без транспорта' :value='true'></v-radio>
        </v-radio-group>
      </template>
      <template v-slot:Vehicle.Volume='{rules,input}'>
        <v-autocomplete
            :class="waybill.NoTransport ? 'transport' : ''"
            :items='vehicles$'
            v-stream:keyup.native='searchVehicle$'
            hide-no-data
            v-model='waybill.Vehicle.Id'
            :rules='[...rules]'
            :disabled='!input.isEdit'
            clearable
            @change='changeVehicle'
            dense
            outlined
            hide-selected
            item-text='Volume'
            item-value='Id'
            label='Автомобиль'
            return-object
        >
          <template v-slot:item='{item}'>
            <template>
              <v-list-item-content>
                {{ item.Name }}: "{{ item.ModelRegistrationNumber }}"
                Литраж: "{{ item.Volume }}"
              </v-list-item-content>
            </template>
          </template>
          <template v-slot:prepend-inner>
            <oil-modal
                maxWidth='1024'
                mdiColor='blue'
                :persistent='false'
                mdiIcon='mdi-dump-truck'
            >
              <template v-slot:body='{dialog}'>
                <v-card>
                  <v-card-text>
                    <v-card-title>
                      {{ 'создать автомобиль'.toUpperCase() }}
                    </v-card-title>
                    <v-text-field v-model='vehicle.Name' outlined dense label='Название' />
                    <v-text-field v-model='vehicle.Model' outlined dense label='Модель' />
                    <v-text-field v-model='vehicle.ModelRegistrationNumber' outlined dense
                                  label='Гос. регистрационный номер авто' />
                    <v-text-field v-model='vehicle.Volume' outlined dense label='Литраж' />
                    <v-btn @click='saveVehicle(vehicle,dialog)' color='primary' class='mr-2'>Добавить</v-btn>
                    <v-btn text @click='dialog.value = false'>Закрыть</v-btn>
                  </v-card-text>
                </v-card>
              </template>
            </oil-modal>
          </template>
        </v-autocomplete>
      </template>
      <template v-slot:Driver.Name='{rules,input}' class='hover'
      >
        <v-autocomplete
            :class="waybill.NoTransport ? 'transport' : ''"
            :items='drivers$'
            v-stream:keyup.native='searchDriver$'
            hide-no-data
            v-model='waybill.Driver.Id'
            :disabled='!input.isEdit'
            :rules='[...rules]'
            clearable
            @change='changeDriver'
            dense
            outlined
            hide-selected
            item-value='Id'
            item-text='Name'
            label='Водитель'
            return-object
        >
          <template v-slot:prepend-inner>
            <oil-modal
                maxWidth='800'
                mdiColor='blue'
                :persistent='false'
                mdiIcon='mdi-transit-transfer'
            >
              <template v-slot:body='{dialog}'>
                <v-card>
                  <v-card-text>
                    <v-card-title>
                      {{ 'создать водителя'.toUpperCase() }}
                    </v-card-title>
                    <v-text-field v-model='driver.Name' outlined dense label='Имя' />
                    <v-btn @click='saveDriver(driver,dialog)' color='primary' class='mr-2'>Добавить</v-btn>
                    <v-btn text @click='dialog.value = false'>Закрыть</v-btn>
                  </v-card-text>
                </v-card>
              </template>
            </oil-modal>
          </template>
        </v-autocomplete>
      </template>
      <template v-slot:Vehicle.Trailer1='{input}'>
        <v-text-field
            v-model='waybill.Vehicle.Trailer1'
            :class="waybill.NoTransport ? 'transport' : ''"
            :disabled='!input.isEdit'
            label='Прицеп №1'
            outlined
            dense
        />
      </template>
      <template v-slot:Vehicle.Trailer2='{input}'>
        <v-text-field
            v-model='waybill.Vehicle.Trailer2'
            :class="waybill.NoTransport ? 'transport' : ''"
            :disabled='!input.isEdit'
            label='Прицеп №2'
            outlined
            dense
        />
      </template>
      <template v-slot:Convoy='{input}'>
        <v-text-field
            v-model='waybill.Convoy'
            :class="waybill.NoTransport ? 'transport' : ''"
            :disabled='!input.isEdit'
            label='Сопровождающий'
            outlined
            dense
        />
      </template>
      <template v-slot:Carrier='{input}'>
        <v-text-field
            v-model='waybill.Carrier'
            :class="waybill.NoTransport ? 'transport' : ''"
            :disabled='!input.isEdit'
            label='Перевозчик'
            outlined
            dense
        />
      </template>
      <template v-slot:ShipmentDoneBy='{input}'>
        <v-text-field
            v-model='waybill.ShipmentDoneBy'
            :class="waybill.NoTransport ? 'transport' : ''"
            :disabled='!input.isEdit'
            label='Отпуск произвел'
            outlined
            dense
        />
      </template>
      <template v-slot:ShipmentAllowedBy='{input}'>
        <v-text-field
            v-model='waybill.ShipmentAllowedBy'
            :class="waybill.NoTransport ? 'transport' : ''"
            :disabled='!input.isEdit'
            label='Отпуск разрешил'
            outlined
            dense
        />
      </template>
      <template v-slot:WaybillNote='{input}'>
        <v-text-field
            v-model='waybill.WaybillNote'
            :class="waybill.NoTransport ? 'transport' : ''"
            :disabled='!input.isEdit'
            label='Путевой лист'
            outlined
            dense
        />
      </template>
      <template v-slot:Seals='{input}'>
        <v-text-field
            v-model='waybill.Seals'
            :class="waybill.NoTransport ? 'transport' : ''"
            :disabled='!input.isEdit'
            label='Пломбы'
            outlined
            dense
        />
      </template>
      <!--      <template v-slot:Contract.Id='{rules,input}'>-->
      <!--        <v-autocomplete-->
      <!--          :items='contracts$'-->
      <!--          v-stream:keyup.native='searchContract$'-->
      <!--          hide-no-data-->
      <!--          :rules='[...rules]'-->
      <!--          :clearable='!isReadonlyy.contract'-->
      <!--          :disabled='!input.isEdit'-->
      <!--          :readonly='isReadonlyy.contract'-->
      <!--          @change='changeContract'-->
      <!--          dense-->
      <!--          outlined-->
      <!--          :value='waybill.Contract.Number'-->
      <!--          hide-selected-->
      <!--          item-text='Number'-->
      <!--          label='Выбрать договор'-->
      <!--          return-object-->
      <!--        ></v-autocomplete>-->
      <!--      </template>-->
      <!--      <template v-slot:Vehicle.Volume='{rules,input}'>-->
      <!--        <v-autocomplete-->
      <!--          :items='vehicles$'-->
      <!--          v-stream:keyup.native='searchVehicle$'-->
      <!--          hide-no-data-->
      <!--          :rules='[...rules]'-->
      <!--          :disabled='!input.isEdit'-->
      <!--          clearable-->
      <!--          @change='changeVehicle'-->
      <!--          dense-->
      <!--          outlined-->
      <!--          v-model='waybill.Vehicle.Name'-->
      <!--          hide-selected-->
      <!--          item-value='Name'-->
      <!--          item-text='Model'-->
      <!--          label='Автомобиль'-->
      <!--          return-object-->
      <!--        >-->
      <!--          <template v-slot:item='{item}'>-->
      <!--            <template>-->
      <!--              <v-list-item-content>-->
      <!--                Модель: "{{ item.ModelRegistrationNumber }}"-->
      <!--                Литраж: "{{ item.Volume }}"-->
      <!--              </v-list-item-content>-->
      <!--            </template>-->
      <!--          </template>-->
      <!--          <template v-slot:prepend-inner>-->
      <!--            <oil-modal-->

      <!--              maxWidth='1024'-->
      <!--              mdiColor='blue'-->
      <!--              :persistent='false'-->
      <!--              mdiIcon='mdi-dump-truck'-->
      <!--            >-->
      <!--              <template v-slot:body='{dialog}'>-->
      <!--                <v-card>-->
      <!--                  <v-card-text>-->
      <!--                    <v-card-title>-->
      <!--                      {{ 'создать автомобиль'.toUpperCase() }}-->
      <!--                    </v-card-title>-->
      <!--                    <v-text-field v-model='vehicle.Name' outlined dense label='Название' />-->
      <!--                    <v-text-field v-model='vehicle.Model' outlined dense label='Модель' />-->
      <!--                    <v-text-field v-model='vehicle.ModelRegistrationNumber' outlined dense-->
      <!--                                  label='Гос. регистрационный номер авто' />-->
      <!--                    <v-text-field v-model='vehicle.Volume' outlined dense label='Литраж' />-->
      <!--                    <v-btn @click='saveVehicle(vehicle,dialog)' color='primary' class='mr-2'>Добавить</v-btn>-->
      <!--                    <v-btn text @click='dialog.value = false'>Закрыть</v-btn>-->
      <!--                  </v-card-text>-->
      <!--                </v-card>-->
      <!--              </template>-->
      <!--            </oil-modal>-->
      <!--          </template>-->
      <!--        </v-autocomplete>-->

      <!--      </template>-->
      <!--      <template v-slot:Driver.Name='{rules,input}'>-->
      <!--        <v-autocomplete-->
      <!--          :items='drivers$'-->
      <!--          v-stream:keyup.native='searchDriver$'-->
      <!--          hide-no-data-->
      <!--          :disabled='!input.isEdit'-->
      <!--          :rules='[...rules]'-->
      <!--          clearable-->
      <!--          @change='changeDriver'-->
      <!--          dense-->
      <!--          outlined-->
      <!--          v-model='waybill.Driver.Name'-->
      <!--          hide-selected-->
      <!--          item-text='Name'-->
      <!--          label='Водитель'-->
      <!--          return-object-->
      <!--        >-->
      <!--          <template v-slot:prepend-inner>-->
      <!--            <oil-modal-->
      <!--              maxWidth='800'-->
      <!--              mdiColor='blue'-->
      <!--              :persistent='false'-->
      <!--              mdiIcon='mdi-transit-transfer'-->
      <!--            >-->
      <!--              <template v-slot:body='{dialog}'>-->
      <!--                <v-card>-->
      <!--                  <v-card-text>-->
      <!--                    <v-card-title>-->
      <!--                      {{ 'создать водителя'.toUpperCase() }}-->
      <!--                    </v-card-title>-->
      <!--                    <v-text-field v-model='driver.Name' outlined dense label='Имя' />-->
      <!--                    <v-btn @click='saveDriver(driver,dialog)' color='primary' class='mr-2'>Добавить</v-btn>-->
      <!--                    <v-btn text @click='dialog.value = false'>Закрыть</v-btn>-->
      <!--                  </v-card-text>-->
      <!--                </v-card>-->
      <!--              </template>-->
      <!--            </oil-modal>-->
      <!--          </template>-->

      <!--        </v-autocomplete>-->
      <!--      </template>-->

      <template v-slot:Terminal.Id>
        <div class='parent'>
          <v-select
              @change='changeTerminal'
              label='Пункт погрузки'
              return-object
              :items='terminals'
              item-text='Name'
              item-value='Id'
              outlined
              dense
          />
          <v-checkbox
              class='absolute'
              hide-details
              v-model='waybill.TerminalShow'
              outlined
              dense
          >
          </v-checkbox>
        </div>

      </template>

      <template v-slot:Product='{input}'>
        <OilProduct
            :input='input'
            :contract='waybill.Contract'
            :item='waybill.Item'
        />
      </template>
    </oil-form>
  </div>
</template>

<script>

import { companiesService } from '@/services/CompaniesService.js'
import { contractsService } from '@/services/ContractsService.js'
import { waybillService } from '@/services/WayBillService'
import { orderService } from '@/services/OrderService'
import { ProductCalc } from '@/utils/functions/Product'
import Waybill from './model/waybill'
import { vehicleService } from '@/services/VehicleService'

import create_order from './globalFunctionsInThisDirectory'

export default {


  props: {
    orderId: {
      type: String,
      required: true
    }
  },


  data() {
    return {
      isReadonlyy: {
        buyer: false,
        contract: false,
        appendix: false,
        empowerment: false,
        order: false
      },
      waybillNoTransport: false

    }
  },
  mixins: [create_order],
  computed: {
    message() {
      return this.id ? 'поздравлаем ТТН удачно изменен' : 'поздравлаем ТТН удачно создан'
    }
  },


  methods: {
    async formCallback(waybill, input) {

      input.isEdit = false

      const item = waybill.Item
      console.log(item)
      const liter = parseFloat(item.AmountInLitre)
      const volume = parseFloat(waybill.Vehicle.Volume)
      console.log(liter + ',' + volume)
      if (isNaN(liter) && isNaN(volume)) {
        this.$notify({
          group: 'mgs',
          type: 'error',
          title: `некорректные данные`
        })
        input.isEdit = true
        return
      }

      // if (liter > volume) {
      //   this.$notify({
      //     group: 'mgs',
      //     type: 'error',
      //     title: `литр ${liter} превышает лимит  ${volume}`
      //   })
      //
      //   input.isEdit = true
      //   return
      // }


      waybill.TotalExcise = ProductCalc.TotalExcise(item)
      waybill.VAT = ProductCalc.TotalNds(item)
      waybill.NetTotal = ProductCalc.PriceClearTons(item)
      waybill.TotalNproductsoVat = ProductCalc.PriceClearNdsPrices(item)
      waybill.TotalPriceInText = item.TotalPriceInText
      waybill.Total = ProductCalc.TotalPrice(item)
      waybill.TotalNoVat = ProductCalc.PriceClearNdsPrices(item)
      waybill.Item.NetPricePerTonne = ProductCalc.PriceClearNdsPrice(item)
      const response = await waybillService.create(waybill)

      const id = response.data?.Id

      if (!id) {
        input.isEdit = true
        return
      }

      this.openPdf(id, 'waybill/print')

      await this.$router.push({
        name: 'waybill-update',
        params: { id: id }
      })

    }
  },
  async created() {
    this.isReadonlyy.buyer = false
    this.isReadonlyy.contract = false
    this.isReadonlyy.appendix = false
    this.isReadonlyy.order = false
    this.isReadonlyy.empowerment = false
    this.reset()
    this.waybill = new Waybill().wayBill
    const seller = await companiesService.seller()

    const getOrder = await orderService.getOrders()
    this.orders = getOrder.data

    const {
      CompanyName,
      Address
    } = seller.data
    this.waybill.SellerNameWithAddress = `${CompanyName} ${Address}`
    const companies = await companiesService.getAll()

    this.buyers = companies?.data || []
    const response = await orderService.getById(this.orderId)

    const vehicles = await vehicleService.getAll({ isOwn: true })

    this.vehicles$ = vehicles.data || []


    const order = response.data
    const buyer = order?.Buyer
    this.waybill.Order = order
    this.keys['Order.Id'].attrs.items.push({ ...order })

    if (!buyer) {

      this.isReadonlyy.buyer = false
      this.isReadonlyy.contract = false
      this.isReadonlyy.appendix = false
      this.isReadonlyy.order = !!order
      this.isReadonlyy.empowerment = false
      this.waybill = new Waybill().wayBill

      this.waybill.Order = order || {
        Id: null,
        Number: null
      }
      this.loading = true
      return
    }

    const buyerId = buyer?.Id

    const contracts = await contractsService.contractCompanyById({ companyId: buyerId })

    const id = order?.waybill?.Vehicle?.Id

    if (id) {
      const resp = await vehicleService.getById({ id: id, isOwn: true })
      await this.changeVehicle(resp.data)
    }


    this.contracts = contracts?.data || []
    const contractId = order?.Contract?.Id

    if (!contractId) {
      this.waybill.Contract = { Id: null }
      this.loading = true
      return
    }
    if (!order?.Empowerment) {
      this.waybill.Empowerment = {
        Id: null
      }
    }

    const contract = this.contracts.find(({ Id }) => Id === contractId)

    await this.changeBuyer(contract?.Buyer)

    await this.changeContract(contract)

    this.appendixes = contract.Appendixes || []

    const appendixId = order.Appendix?.Id

    const appendix = this.appendixes.find(({ Id }) => Id === appendixId)

    this.waybill.Order = order || { Id: null }
    this.waybill.Empowerment = order?.Empowerment || { Id: null }

    await this.changeAppendix(appendix)
    this.isReadonlyy.buyer = !!buyer
    this.isReadonlyy.contract = !!contract
    this.isReadonlyy.appendix = !!appendix
    this.isReadonlyy.order = !!order
    this.isReadonlyy.empowerment = !!this.waybill.Empowerment.Id

    this.loading = true

  },
  watch: {
    waybillNoTransport(val){
      this.waybill.NoTransport = val
    },
    'isReadonlyy.appendix'(appendix) {
      this.keys['Appendix.Id'].attrs.readonly = appendix
    },
    'isReadonlyy.empowerment'(empowerment) {
      this.keys['Empowerment.Id'].attrs.readonly = empowerment
    },
    'isReadonlyy.order'(order) {
      this.keys['Order.Id'].attrs.readonly = order
    }

  }
}
</script>

<style>


.parent {
  position: relative;
}

.transport {
  display: none !important;
}

.absolute {
  position: absolute;
  left: 100%;
  right: 0;
  top: -12px;
}
</style>